<script setup>
import { ref, computed, watch } from "vue";
import { alertError } from "@/utils/alerts";
import { alertConfirmar } from "@/utils/alerts";
import { formatearInputMoneda } from "@/utils/helpers";
import { Modal } from "bootstrap";

const props = defineProps({
  garantiasStore: Object,
});

const montoDevolucion = ref(null);
const cbuDevolucion = ref(null);

const montoMaximo = computed(() => {
  const saldo = Number(props.garantiasStore?.resumen?.saldo) || 0;
  const ofertado = Number(props.garantiasStore?.resumen?.ofertado) || 0;
  const max = saldo - ofertado * 0.1;
  return Math.max(0, max);
});

watch(
  montoMaximo,
  (nuevo) => {
    if (nuevo > 0) montoDevolucion.value = nuevo;
    else montoDevolucion.value = null;
  },
  { immediate: true }
);

async function pedirDevolucion() {
  const max = montoMaximo.value;
  const monto = Number(montoDevolucion.value) || 0;
  const moneda = 'ARS';

  if (monto <= 0) {
    alertError("El monto debe ser mayor a 0");
    return;
  }
  if (monto > max) {
    alertError("El monto supera el máximo posible");
    return;
  }

  if (cbuDevolucion.value.length !== 22) {
    alertError("El cbu tiene debe tener 22 números");
    return;
  }

  try {
    props.garantiasStore.pedirDevolucion(monto,moneda,cbuDevolucion.value);
    alertConfirmar(
      "Se ha realizado el pedido de devolución. Debe esperar a ser aprobado."
    );
    closeModal();
    await props.garantiasStore.obtenerResumenGarantia();
    props.garantiasStore.obtenerMisMovimientosGarantias();
  } catch (error) {
    console.log(error);
  }
}

function formatearNumero(event) {
  const soloDigitos = event.target.value.replace(/\D/g, "");
  const valor = soloDigitos ? Number(soloDigitos) : null;

  if (valor === null) {
    montoDevolucion.value = null;
    return;
  }

  const max = montoMaximo.value;
  montoDevolucion.value = valor > max ? max : valor;
}

function closeModal() {
  const el = document.getElementById("pedido-devolucion-modal");
  if (!el) return;
  const modal = Modal.getInstance(el) ?? new Modal(el);
  modal.hide();
}
</script>

<template>
  <div
    class="modal fade"
    id="pedido-devolucion-modal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-0" style="border-radius: 12px">
        <div class="modal-header">
          <h5 class="modal-title">Pedir devolución</h5>
          <button type="button" data-bs-dismiss="modal">
            <i class="fa fa-times"></i>
          </button>
        </div>

        <div class="modal-body">
          <ul class="list-unstyled small mb-0">
            <label class="text-sm">
              Monto para pedir devolución (recordá que por los lotes con ofertas
              ganadoras se les retiene un 10% del total)
            </label>

            <input
              id="importe"
              type="text"
              class="form-control input-with-icon"
              placeholder="$"
              :value="formatearInputMoneda(montoDevolucion ?? 0)"
              @input="formatearNumero"
              inputmode="numeric"
              pattern="\d*"
            />

            <small class="text-muted text-sm">
              Máximo permitido: {{ formatearInputMoneda(montoMaximo) }}
            </small>
          </ul>
          <ul class="list-unstyled small mb-0">
            <label class="text-sm">
              CBU para recibir la devolución
            </label>

            <input
              id="importe"
              type="text"
              class="form-control input-with-icon"
              v-model="cbuDevolucion"
            />
          </ul>
        </div>

        <div class="modal-footer">
          <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
            Cancelar
          </button>
          <button
            class="btn btn-primary"
            @click.prevent="pedirDevolucion"
            :disabled="
              !montoDevolucion ||
              montoDevolucion <= 0 ||
              montoDevolucion > montoMaximo
            "
          >
            Pedir devolución
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
